import { toast } from "react-toastify";
import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  changeImageBirthdayStart,
  changeImageBirthdaySuccess,
  changeImageBirthdayFailed,
} from "../redux/changeImageBirthday";

import { postChangeImageBirthdayApi } from "core/http/service/accountInfo";
import { closeDialog } from "redux-store/static/redux/dialog";
import { DIALOG } from "helper/enum/dialogEnum";

function* changeImageBirthdayWork(
  action: ReturnType<typeof changeImageBirthdayStart>
) {
  try {
    const res = yield call(postChangeImageBirthdayApi, {
      file: action.payload,
    });
    yield put({
      type: changeImageBirthdaySuccess.type,
      payload: res,
    });

    yield put({
      type: closeDialog.type,
      payload: { key: DIALOG.CHANGE_AVATAR },
    });

    toast.success("Cập nhật ảnh sinh nhật thành công");
  } catch (error: any) {
    yield put({
      type: changeImageBirthdayFailed.type,
    });
    toast.error("Thay đổi ảnh sinh nhật không thành công, vui lòng thử lại");
  }
}

function* watchChangeImageBirthday() {
  yield takeLatest(changeImageBirthdayStart.type, changeImageBirthdayWork);
}

export default function* ChangeImageBirthdaySaga() {
  yield all([watchChangeImageBirthday()]);
}
